import config from "config";

import useFlags from "components/FeatureFlag/useFlags";

function useIntercomFeatureFlag() {
  const { loadingConfig, flags } = useFlags();
  if (loadingConfig) return { loading: true, appId: null };

  const ff = flags?.["intercom-migration"];
  const useEnv = ff?.useEnv;
  const flagAppId = ff?.appId?.trim() || null;
  const configAppId = config.intercom?.appId?.trim() || null;

  if (!ff) return { loading: false, appId: configAppId };

  if (useEnv) return { loading: false, appId: configAppId };

  if (!useEnv && !flagAppId) {
    console.warn("[Intercom]", "useEnv=false but flag appId missing");
    return { loading: false, appId: null };
  }

  return { loading: false, appId: flagAppId };
}

export default useIntercomFeatureFlag;
